var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#895AF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99563 8.01566C10.0855 8.01026 10.1757 8.01026 10.2656 8.01566C11.0981 8.07191 11.4806 9.20254 12.0094 9.14066C11.5138 9.54577 10.939 9.84275 10.3219 10.0125C10.0653 10.05 9.80369 9.99765 9.58127 9.8644C9.35885 9.73115 9.18928 9.52517 9.10125 9.28129V11.5313L12.375 9.66379V6.75004L9.99563 8.01566ZM8.37 8.01004C8.24589 7.90719 8.14473 7.77946 8.07303 7.6351C8.00134 7.49074 7.9607 7.33295 7.95375 7.17191V7.12691C7.95375 6.47441 9.00562 5.43941 9.03937 5.43941C9.07312 5.47316 10.125 6.48004 10.125 7.12691V7.17754C10.115 7.46643 9.9941 7.74037 9.7875 7.94254L12.375 6.55316L9 4.89941L5.625 6.53629L8.37 8.01004ZM8.92125 9.30379C8.83424 9.54872 8.6651 9.75595 8.44258 9.89029C8.22006 10.0246 7.95789 10.0778 7.70062 10.0407C7.08349 9.87088 6.50868 9.57389 6.01312 9.16879C6.54187 9.20816 6.91875 8.07191 7.75688 8.04379C7.84679 8.03838 7.93696 8.03838 8.02688 8.04379L5.625 6.75004V9.66941L8.92687 11.5763L8.92125 9.30379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25C5.27231 2.25 2.25 5.27231 2.25 9C2.25 12.7277 5.27231 15.75 9 15.75C12.7277 15.75 15.75 12.7277 15.75 9C15.75 7.20979 15.0388 5.4929 13.773 4.22703C12.5071 2.96116 10.7902 2.25 9 2.25ZM5.23125 6.29437L9 4.46625L12.7744 6.29437V9.88875L9 12.0656L5.23125 9.88875V6.29437ZM12.7856 11.3569L9.02812 13.5281L5.22563 11.3344V11.1263L9.02812 13.32L12.7856 11.1488V11.3569ZM12.7856 10.935L9.02812 13.1062L5.22563 10.9125V10.6875L9.02812 12.8869L12.7856 10.7156V10.935ZM12.7856 10.5131L9.02812 12.6844L5.22563 10.4906V10.2825L9.02812 12.4819L12.7856 10.3106V10.5131Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTks);
export default __webpack_public_path__ + "static/media/tks.4bb7aab35b94845c6ca01521f9040dc7.svg";
export { ForwardRef as ReactComponent };